"use client";

import type { MuhuratResponse } from "@/lib/api/muhurat";

interface InauspiciousSlotsProps {
  data: MuhuratResponse;
}

export function InauspiciousSlots({ data }: InauspiciousSlotsProps) {
  const items = [
    {
      label: "Rahu Kaal",
      hi: data.rahu_kaal.label_hi,
      start: data.rahu_kaal.start,
      end: data.rahu_kaal.end,
      isMain: true,
    },
    {
      label: "Yamagandam",
      hi: data.yamagandam.label_hi,
      start: data.yamagandam.start,
      end: data.yamagandam.end,
    },
    {
      label: "Gulika Kaal",
      hi: data.gulika_kaal.label_hi,
      start: data.gulika_kaal.start,
      end: data.gulika_kaal.end,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {items.map((item) => (
        <div
          key={item.label}
          className={`flex flex-col items-center justify-center p-5 rounded-2xl border text-center transition-all ${
            item.isMain ? "bg-red-50 border-red-200/50 shadow-sm" : "bg-red-50/30 border-red-100"
          }`}
        >
          <span className="text-[10px] font-bold text-red-600 uppercase tracking-widest mb-0.5">
            {item.hi}
          </span>
          <span className="text-xs font-bold text-red-500 uppercase tracking-wider mb-2">
            {item.label}
          </span>
          <span className="font-serif text-xl font-bold text-red-900 leading-none">
            {item.start} - {item.end}
          </span>
        </div>
      ))}
    </div>
  );
}
